export const SECTION_LOGO = 'SECTION_LOGO';
export const SECTION_BigBang = 'SECTION_BigBang';
export const SECTION_SHOWS = 'SECTION_SHOWS';
export const SECTION_MEMBERS = 'SECTION_MEMBERS';
export const SECTION_TEACHERS = 'SECTION_TEACHERS';
export const SECTION_MERCHANDISE = 'SECTION_MERCHANDISE';
export const SECTION_RESOURCES = 'SECTION_RESOURCES';
export const SECTION_ABOUT = 'SECTION_ABOUT';